import { ObservableQuery } from '@apollo/client';
import { ProjectMember, ProjectRole } from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRolesSuccess {
  public static readonly type =
    '[Project/ProjectRoles/List] FindAllDefaultRolesSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      getBaseProjectRoles: ProjectRole[];
    }>,
    public readonly members: ProjectMember[],
  ) {}
}
